import { combineReducers } from '@reduxjs/toolkit'
import user from './user'
import userSubGroup from './userSubGroup'
import clientUserGroups from './clientUserGroups'

const subscription = combineReducers({
  user,
  userSubGroup,
  clientUserGroups,
})

export type SubscriptionState = ReturnType<typeof subscription>

export default subscription
